export type { FilterOption, FilterSection, FilterStrengthGroup } from "./components/AttributeFilterSections";

export type FilterSectionConfig = {
  attributeCode: string;
};

export type AttributeAggregationOption = {
  value: string;
  label: string;
};

export type AttributeAggregation = {
  attributeCode: string;
  label: string;
  options: AttributeAggregationOption[];
};

export type SelectedAttributes = Record<string, string[]>;

export type RawAttributeAggregationOption = {
  label: string | null;
  value: string;
};

export type RawAttributeAggregation = {
  attribute_code: string;
  label: string | null;
  options: (RawAttributeAggregationOption | null)[] | null;
};

export type RawAttributeAggregations = (RawAttributeAggregation | null)[] | null | undefined;
